var data = {
	"body": "<path d=\"M13.71 12.59a1 1 0 0 0-1.39-.26l-6.53 4.45a1 1 0 0 0 0 1.65l6.53 4.45a1 1 0 1 0 1.13-1.65l-5.32-3.62L13.45 14a1 1 0 0 0 .26-1.41z\" class=\"clr-i-outline clr-i-outline-path-1\" fill=\"currentColor\"/><path d=\"M30.21 16.78l-6.53-4.45A1 1 0 1 0 22.55 14l5.32 3.63l-5.32 3.63a1 1 0 0 0 1.13 1.65l6.53-4.45a1 1 0 0 0 0-1.65z\" class=\"clr-i-outline clr-i-outline-path-2\" fill=\"currentColor\"/><path d=\"M19.94 9.83a.9.9 0 0 0-1.09.66l-3.44 13.8a.9.9 0 0 0 .66 1.09h.22a.9.9 0 0 0 .87-.68l3.44-13.81a.9.9 0 0 0-.66-1.06z\" class=\"clr-i-outline clr-i-outline-path-3\" fill=\"currentColor\"/>",
	"width": 36,
	"height": 36
};
exports.__esModule = true;
exports.default = data;
